import React from 'react';

import { calculateDuration, formatTime } from 'utils/datetime';

import styles from './styles.module.css';

const NO_TIME_DEFINED = '--:--';

const formatShiftTime = (timestamp, timezone = null) => {
	const rendered = formatTime(timestamp, { timezone: timezone ?? undefined });
	return rendered || NO_TIME_DEFINED;
};

const ShiftTimeLabel = ({
	shift,
	timezone = null,
	isStartInTimeWindow = true,
	isEndInTimeWindow = true,
}) => {
	if (!shift?.fromTimestamp || !shift?.toTimestamp) {
		return null;
	}

	const from = formatShiftTime(shift.fromTimestamp, timezone);
	const to = formatShiftTime(shift.toTimestamp, timezone);
	const duration = calculateDuration(shift.fromTimestamp, shift.toTimestamp);

	const lineClasses = [styles.shiftLine];
	if (!isStartInTimeWindow) lineClasses.push(styles.openStart);
	if (!isEndInTimeWindow) lineClasses.push(styles.openEnd);

	return (
		<div className={styles.shiftTrack}>
			<div className={styles.shiftLabel}>{`${from} - ${to} / ${duration}`}</div>
			<div data-testid="shift-line" className={lineClasses.join(' ')} />
		</div>
	);
};

export default ShiftTimeLabel;
